/**
 * Skybox — flat neutral-grey editor background (replaces the old equirect
 * PhotoDome). Just sets the scene clear colour; there's no background mesh, so
 * clicking empty space is picked as nothing and the Picker deselects. Kept as a
 * class (and still emits staticAssets:loaded) for API/loader-flag compatibility.
 */

import { Color4, type Scene, type Camera } from 'babylonjs';
import type { EventBus } from '@shared/events/EventBus';
import type { EditorEvents } from '@shared/events/EventTypes';

// Neutral grey viewport background (lightened a touch).
export const BACKGROUND_COLOR = new Color4(0.29, 0.298, 0.31, 1);

export class Skybox {
  constructor(scene: Scene, events: EventBus<EditorEvents>) {
    scene.clearColor = BACKGROUND_COLOR.clone();
    // No async asset to load; signal "ready" so loader flags don't stall.
    events.emit('staticAssets:loaded', { type: 'skybox' });
  }

  update(_camera: Camera): void {
    /* no-op — flat background */
  }

  cleanup(): void {
    /* nothing to dispose */
  }
}

export default Skybox;
